import React, { useEffect, useState, useContext } from "react";
import { ActivitySummary } from "../../../models/WidgestModels";
import "./StatusTiles.scss";
import Service from "../../../services";
import { catchError, textReadableFormat } from "../../../utils/Utils";
import { AxiosError, AxiosResponse } from "axios";
import { BankUserContext } from "../../../bankUserContext";
import { textFormatter } from "../../../utils/GeneralUtils";
import {CSSTransition,TransitionGroup} from 'react-transition-group';

interface StatusTilesProps {
  statusFilters: Function;
}

const StatusTiles = (props: StatusTilesProps) => {
  const [statusPanel, setStatusPanelData] = useState<ActivitySummary[]>([]);
  const [showingStatusPanels, setShowingStatusPanels] = useState<ActivitySummary[]>([]);
  const [selectedStatusTile, setselectedStatusTile] = useState<string | null>();
  const service = new Service();
  const context = useContext(BankUserContext);

  useEffect(() => {
    if (context.bankuserDetails) getStatTiles();
  }, [context.bankuserDetails]);

  const getStatTiles = () => {
    const data = {
      isJsonReturnObject: false,
      userId: context?.bankuserDetails?.userId,
      screen: "LandingPage",
      sections: "getStats",
    };
    service
      .getStatTiles(data)
      .then((response: AxiosResponse) => {
        if(response.data){
          const modifiedVersion = response.data?.filter((m: any) => m.count).map((m: any, index: number) => {
            return { ...m, index};
          });
          
          setStatusPanelData(modifiedVersion);
          setShowingStatusPanels(        
            modifiedVersion.slice(0, 6)
          );
        }
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  const statusFilters = (filterTodo: string) => {
    if (selectedStatusTile == filterTodo) {
      setselectedStatusTile(null);
      props.statusFilters(null);
    } else {
      setselectedStatusTile(filterTodo);
      props.statusFilters(filterTodo);
    }
  };

  const prev = ()=>{
    const indexValue = showingStatusPanels[0].index-6>0?showingStatusPanels[0].index-6:0;
    const prevArray = statusPanel.slice(indexValue,showingStatusPanels[0].index);
    if(prevArray.length===6) setShowingStatusPanels(prevArray.sort((a, b) => a.index - b.index))
    else{
    const filterData = showingStatusPanels.slice(0,6-prevArray.length)
    setShowingStatusPanels([...filterData,...prevArray].sort((a, b) => a.index - b.index))
    
    } 
  }

  const nextAction = () =>{
    const nextArray=statusPanel.slice(showingStatusPanels[showingStatusPanels.length-1].index+1,showingStatusPanels[showingStatusPanels.length-1].index+7)  
    if(nextArray.length===6) setShowingStatusPanels(nextArray.sort((a, b) => a.index - b.index))
    else{      
      const filterData = showingStatusPanels.slice(nextArray.length-6)
      setShowingStatusPanels([...filterData,...nextArray].sort((a, b) => a.index - b.index))
    }
  }

  const showNextAndPrevButton=(button:string)=>{
   
    if(statusPanel.length>6 && showingStatusPanels.length>0) {
     if( button === "next" && showingStatusPanels[showingStatusPanels.length-1].index!== statusPanel.length-1) return true
     if(button==="prev" &&  showingStatusPanels[0].index!== statusPanel[0].index) return true
    }
    return false        
  }



  return (
    <div className="status-panel-main widget">
      {showingStatusPanels && showingStatusPanels?.length > 0 ? (
        <div className="status-panel-main widget">
          
         {<div className={`arrow ${!showNextAndPrevButton("prev")?"arrowDisplay":""}`} onClick={()=>prev()}>
            <div className="arrow-left"></div>
          </div>}       
          
          {showingStatusPanels?.map((m) => (
          
            <div
              className={`status-item ${
                selectedStatusTile === m.interactionid ? "selectedTile" : ""
              }`}
              key={m.interactionid}
              onClick={
                m.isapirequired
                  ? () => statusFilters(m.interactionid)
                  : () => {}
              }
            >
              <div className="value">{m.count}</div>
              <div className="label">{textFormatter(m.interactionname)}</div>
            </div>
                        
          ))}
          { <div className={`arrow ${!showNextAndPrevButton("next")?"arrowDisplay":""}`} onClick={nextAction}>
            <div className="arrow-right"></div>
          </div>}
        
        </div>
        
      ) : (
        <div className="not-found">No Data Available</div>
      )}
    </div>
  );
};

export default StatusTiles;
